import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { useContext } from "react";
import { UserContext } from "./state/UserProvider";
import { API } from "../api-map";
import { CHP_LESSON_CONFIG } from "../../data/lesson-config";
import type { User } from "@/types/user";

export const useAdvanceProgramProgress = () => {
  const navigate = useNavigate();
  const { user, setUser, selectedProgram } = useContext(UserContext);

  return useMutation({
    mutationFn: async ({
      userId,
      program,
    }: {
      userId: number;
      program: string;
    }) => {
      console.log("Making request with:", { userId, program });
      const response = await fetch(API.PROGRAM_ADVANCE_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, program }),
      });
      if (!response.ok) throw new Error("Failed to advance program");
      const data = await response.json();
      console.log("Received response:", data);
      return data as User;
    },
    onSuccess: (updatedUser) => {
      console.log("Mutation success, updated user:", updatedUser);
      // Update the user state with the new data
      setUser(updatedUser);

      // Get the new lesson number from the updated user data
      const userProgram = updatedUser.programs.find(
        (p) => p.program === selectedProgram
      );
      console.log("Found user program:", userProgram);
      const newLessonNumber = userProgram?.lastLessonCompleted;
      console.log("New lesson number:", newLessonNumber);

      if (newLessonNumber !== undefined) {
        // Navigate to the next lesson
        const lessons = selectedProgram === "chp" ? CHP_LESSON_CONFIG : [];
        console.log("Available lessons:", lessons);

        // Navigate to the next lesson (current lesson number + 1)
        const nextLesson = lessons[newLessonNumber + 1];
        console.log("Next lesson:", nextLesson);

        if (nextLesson) {
          const nextPath = `/lessons/${selectedProgram}/${nextLesson.lessonCode}`;
          console.log("Navigating to:", nextPath);
          navigate(nextPath);
        } else {
          console.log("No next lesson found, navigating to /lessons");
          navigate("/lessons");
        }
      } else {
        console.log("No new lesson number found");
      }
    },
  });
};
